import Splide from '@splidejs/splide'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['carouselContainer', 'prevButton', 'nextButton'];

  connect() {
    this.splide = null
    this.prevClickHandler = () => this.scrollByHalf('prev')
    this.nextClickHandler = () => this.scrollByHalf('next')

    if (this.hasCarouselContainerTarget) {
      const { left, right } = this.calculatePadding()

      this.splide = new Splide(this.carouselContainerTarget, {
        autoWidth: true,
        waitForTransition: false,
        arrows: false,
        pagination: false,
        padding: { left, right },
      })
      this.splide.mount()

      this.handleResize = this.updatePadding.bind(this)
      window.addEventListener('resize', this.handleResize)
    }

    if (this.hasPrevButtonTarget && this.splide) {
      this.prevButtonTarget.addEventListener('click', this.prevClickHandler)
    }
    if (this.hasNextButtonTarget && this.splide) {
      this.nextButtonTarget.addEventListener('click', this.nextClickHandler)
    }
  }

  disconnect() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
    if (this.hasPrevButtonTarget && this.prevClickHandler) {
      this.prevButtonTarget.removeEventListener('click', this.prevClickHandler)
    }
    if (this.hasNextButtonTarget && this.nextClickHandler) {
      this.nextButtonTarget.removeEventListener('click', this.nextClickHandler)
    }
    if (this.splide) {
      this.splide.destroy()
    }
  }

  scrollByHalf(direction) {
    if (!this.splide) return

    const trackWidth = this.splide.Components.Elements.track.clientWidth
    const slides = this.splide.Components.Slides.get()
    const currentIndex = this.splide.index
    const lastIndex = slides.length - 1

    let accumulatedWidth = 0
    let targetIndex = currentIndex

    if (direction === 'next') {
      for (let i = currentIndex; i <= lastIndex; i++) {
        accumulatedWidth += slides[i].slide.offsetWidth
        targetIndex = i
        if (accumulatedWidth >= trackWidth / 2) break
      }
      if (targetIndex === currentIndex && currentIndex < lastIndex) {
        targetIndex = currentIndex + 1
      }
    } else {
      for (let i = currentIndex; i >= 0; i--) {
        accumulatedWidth += slides[i].slide.offsetWidth
        targetIndex = i
        if (accumulatedWidth >= trackWidth / 2) break
      }
      if (targetIndex === currentIndex && currentIndex > 0) {
        targetIndex = currentIndex - 1
      }
    }

    this.splide.go(targetIndex)
  }

  updatePadding() {
    if (!this.splide) return
    const { left, right } = this.calculatePadding()
    this.splide.options = {
      padding: { left, right },
    }
    this.splide.refresh()
  }

  calculatePadding() {
    const container = this.element.querySelector('.common2-container')
    if (!container) return { left: 0, right: 0 }

    const rect = container.getBoundingClientRect()
    const computedStyle = window.getComputedStyle(container)
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0

    return {
      left: Math.round(rect.left + paddingLeft),
      right: Math.round(window.innerWidth - (rect.right - paddingRight)),
    }
  }
}
